import { Injectable } from '@angular/core';

export enum LocalStorageKey {
  PRINTER = 'printer'
}

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  public getValue<T>(key: LocalStorageKey): T | undefined {
    const value = localStorage.getItem(key)
    if (!value) {
      return undefined
    } else {
      return JSON.parse(value)
    }
  }

  public setValue<T>(key: LocalStorageKey, value: T) {
    localStorage.setItem(key, JSON.stringify(value))
  }

  public removeValue(key: LocalStorageKey) {
    localStorage.removeItem(key)
  }
}
